import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Package, AlertTriangle, ShoppingCart, Truck, ArrowRight } from "lucide-react";

const eur = (v) => `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const Cell = ({ icon: Icon, label, value, sub, tone, onClick, testId }) => (
  <button type="button" onClick={onClick} className="text-left p-5 border hover:bg-black/[.03] transition-colors" style={{ borderColor: "var(--border)" }} data-testid={testId}>
    <div className="label-caps mb-3 flex items-center gap-2"><Icon size={12} className={tone}/> {label}</div>
    <div className={`h-editorial text-3xl ${tone || ""}`}>{value}</div>
    {sub && <div className="text-xs opacity-60 mt-1">{sub}</div>}
  </button>
);

export function StockOverviewCard() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/inventory/overview").then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const needs = () => nav("/materials-inventory?tab=needs");
  return (
    <div className="card-dark p-6 mb-8" data-testid="stock-overview">
      <div className="flex items-center justify-between mb-5">
        <div className="label-caps">Magazzino</div>
        <button onClick={needs} className="text-xs uppercase tracking-widest inline-flex items-center gap-1 opacity-70 hover:opacity-100" data-testid="stock-overview-open">Fabbisogno <ArrowRight size={12}/></button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Cell icon={Package} label="Valore magazzino" value={eur(d.total_value)} sub={`${d.materials_count} materiali`} onClick={() => nav("/materials-inventory?tab=inventory")} testId="stock-overview-value"/>
        <Cell icon={AlertTriangle} label="Sotto scorta" value={d.low_stock_count} tone={d.low_stock_count ? "text-red-600" : ""} sub="sulla quantità libera" onClick={needs} testId="stock-overview-low"/>
        <Cell icon={ShoppingCart} label="Da ordinare" value={d.to_order_count} tone={d.to_order_count ? "text-orange-600" : ""} sub={`${eur(d.to_order_cost)} · ${d.open_orders} ordini aperti${d.incoming_orders ? ` · ${d.incoming_orders} in arrivo` : ""}`} onClick={needs} testId="stock-overview-to-order"/>
        <Cell icon={Truck} label="Spesa del mese" value={eur(d.month_spent)} sub={d.month_receipts === 1 ? "1 consegna" : `${d.month_receipts} consegne`} onClick={() => nav("/materials-inventory?tab=receipts")} testId="stock-overview-month"/>
      </div>
      {(d.low_stock.length > 0 || d.unmatched_count > 0) && (
        <div className="mt-5 text-sm space-y-1" data-testid="stock-overview-low-list">
          {d.low_stock.map(m => (
            <div key={m.id} className="flex justify-between gap-3 border-b last:border-0 py-1" style={{ borderColor: "var(--border)" }}>
              <span>{m.name}</span><span className="text-xs">Libero <b className="text-red-600">{m.free}</b> {m.unit} · min {m.min_stock}</span>
            </div>
          ))}
          {d.low_stock_count > d.low_stock.length && <div className="text-xs opacity-60">e altri {d.low_stock_count - d.low_stock.length}…</div>}
          {d.unmatched_count > 0 && <button onClick={needs} className="text-xs text-orange-700 mt-2" data-testid="stock-overview-unmatched">{d.unmatched_count} prodotti Shopify da abbinare a un capo</button>}
        </div>
      )}
    </div>
  );
}
